// src/api/smartPlus.js
import request from './request'

/**
 * 获取 Smart+ 素材概览报表
 */
export function getSmartPlusMaterialReport(data) {
    return request({
        url: '/api/smart-plus/material-report/overview',
        method: 'post',
        withCredentials: false,
        data
    })
}
/**
 * 批量启用创意
 */
export function enableMaterials(data) {
    return request({
        url: '/api/smart-plus/ad/material/enable',
        method: 'post',
        withCredentials: false,
        data
    })
}

/**
 * 批量暂停创意
 */
export function disableMaterials(data) {
    return request({
        url: '/api/smart-plus/ad/material/disable',
        method: 'post',
        withCredentials: false,
        data
    })
}
/**
 * 获取推广系列完整数据
 */
export function getCampaignsComplete(params) {
    return request({
        url: '/tiktok/report/campaigns/complete',
        method: 'get',
        withCredentials: false,
        params
    })
}

export function getCampaignsCompleteWithAdgroups(params) {
    return request({
        url: '/tiktok/report/campaigns/complete-with-adgroups',
        method: 'get',
        withCredentials: false,
        params
    })
}
/**
 * 获取所有规则
 */
export function getAllRules() {
    return request({
        url: '/api/tiktok/rules',
        method: 'get',
        withCredentials: false
    })
}

/**
 * 创建规则
 */
export function createRule(data) {
    return request({
        url: '/api/tiktok/rules',
        method: 'post',
        withCredentials: false,
        data
    })
}

/**
 * 更新规则
 */
export function updateRule(id, data) {
    return request({
        url: `/api/tiktok/rules/${id}`,
        method: 'put',
        withCredentials: false,
        data
    })
}

/**
 * 删除规则
 */
export function deleteRule(id) {
    return request({
        url: `/api/tiktok/rules/${id}`,
        method: 'delete',
        withCredentials: false
    })
}

/**
 * 启用/禁用规则
 */
export function toggleRule(id, enabled) {
    return request({
        url: `/api/tiktok/rules/${id}/toggle`,
        method: 'put',
        withCredentials: false,
        params: { enabled }
    })
}

/**
 * 获取规则执行日志
 */
export function getRuleLogs(id) {
    return request({
        url: `/api/tiktok/rules/${id}/logs`,
        method: 'get',
        withCredentials: false
    })
}

/**
 * 手动触发规则执行
 */
export function executeRule(id) {
    return request({
        url: `/api/tiktok/rules/${id}/execute`,
        method: 'post',
        withCredentials: false
    })
}
